import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
import empty_favourite from "./../../assets/Icon/empty_favourite.svg";
import fulfill_favourite from "./../../assets/Icon/fulfill_favourite.svg";
import shopping_cart from "./../../assets/Icon/shopping-cart-red.svg";
import compare from "./../../assets/Icon/compare.svg";
import productTwo_quality_icon from "./../../assets/Product/productTwo_quality_icon.png";
import Heading7 from "./../../Components/Font/Heading7";
import Text4 from "./../../Components/Font/Text4";
import * as services from "../../services/services";
import Text5 from "./../../Components/Font/Text5";
import OldPrice from "./../../Components/Font/OldPrice";
import Price from "./../../Components/Font/Price";
import Heading6 from "./../../Components/Font/Heading6";
import RatingBlock from "./../../Components/MostSharedComponent/RatingBlock";
import AwesomeSlider from "react-awesome-slider";
import "./../../SCSS/MobilePages/Mobile_Product_List_ListDetail.scss";
import { useDispatch, useSelector } from "react-redux";
import {
  loadAddToWishlist,
  loadDeleteFromWishlist,
  loadCartData,
  loadWishlistData,
} from "../../redux/appAction";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useTranslation } from "react-i18next";
import { selectedCompareProductStatus } from "./../../Components/helpers/utils/compareProductsFilter";
import { HiOutlineSwitchHorizontal } from "react-icons/hi";
import { productUrlHelper } from "../helpers/utils/productUrlHelper";
import { addToCart } from "../../services/cart.service";
import { checkWishList } from "../helpers/utils/wishListHelper";
import { titleChange } from "../helpers/utils/titleNameChange";
import MizaAndQitaf from "../MostSharedComponent/MizaAndQitaf";
import ProductLabel from "../MostSharedComponent/ProductLabel";
import TamaraLogoBox from "../MostSharedComponent/TamaraLogoBox";
import { ImageResize } from "../helpers/utils/imageResize";
import { cartEvents } from "../helpers/utils/ga/cartEvents";
import { checkoutEvents } from "../helpers/utils/ga/checkoutEvents";
import DeliveryTimeArea from "../MostSharedComponent/DeliveryTimeArea";
import LazyImageForProduct from "../MostSharedComponent/LazyImageForProduct";
import AddToCartNotify from "../Buttons/AddToCartNotify";
import useCartErrorMessage from "../helpers/hooks/useCartErrorMessage";
import MobileCompareBtn from "../Plp/MobileCompareBtn";
import SoldOutProductLabel from "../MostSharedComponent/SoldOutProductLabel";
import ProductDeliveryType from "../MostSharedComponent/ProductDeliveryType";

var settings = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 1,
  arrows: false,
  // slidesToScroll: 1
};
function MobileListViewProduct({
  product,
  updateCompareProduct,
  handleChangeCartPopup,
  outOfStockConfiguration,
  screenName,
  productIndex,
  availablityData
}) {

  const { setCartErr } = useCartErrorMessage();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isFavouriteHover, setIsFavouriteHover] = useState(false);
  const [isFavourite, setIsFavourite] = useState(false);
  const [sizeButtonIndex, setSizeButtonIndex] = useState(0);
  const [loaderOn, setLoaderOn] = useState(false);
  const [spinnerOn, setSpinnerOn] = useState(false);
  const [count, setCount] = useState(0);
  const [selectedProducts, setSelectedProducts] = useState({});
  const { t } = useTranslation();

  const wishlistData = useSelector((state) => state.appData.wishlistData);

  useEffect(() => {
    setIsFavourite(checkWishList(wishlistData, product?.sku));
  }, []);
  useEffect(() => {
    product.is_price_hide = product.options.find((x) => {
      if (x.code === 'is_price_hide') {
        return x.visibility;
      }
      return false;
    });
  }, [product]);
  const handleFavourite = (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (isFavourite) {
      setIsFavourite(false);
      setCount(count + 1);
    } else {
      setIsFavourite(true);
      setCount(count + 1);
    }
  };
  useEffect(() => {
    const data = {
      items: [product.sku],
    };
    if (isFavourite) {
      if (count > 0) {
        const addToWishlistData = dispatch(loadAddToWishlist(data, t)).then(
          (res) => {
            checkoutEvents.addToWishlist(product, screenName);
            dispatch(loadWishlistData());
          }
        );
      }
    } else {
      if (count > 0) {
        if (!isFavourite) {
          checkoutEvents.removeFromWishlist(product, screenName);
          removeFromWL(product.sku);
        }
      }
    }
  }, [isFavourite]);

  const removeFromWL = (sku) => {
    const data = {
      items: [sku],
    };
    const deleteFromWishlistData = dispatch(loadDeleteFromWishlist(data)).then(
      (res) => {
        dispatch(loadWishlistData());
      }
    );
  };
  const redirectToPdpPage = (url_key, sku) => {
    navigate(productUrlHelper(url_key, sku));
  }

  const AddProductToCart = (sku) => {
    setLoaderOn(true);
    if (product.variants && product.variants.length > 0) {
      sku = product.variants[sizeButtonIndex].sku;
    }

    const data = {
      items: [
        {
          sku: sku,
          qty: 1,
          id: product?.id
        },
      ],
    };

    addToCart(data)
      .then((res) => {
        setSpinnerOn(true)
        dispatch(loadCartData()).then((item) => {
          cartEvents.addToCart(product, item?.id)
          setSpinnerOn(false)
          handleChangeCartPopup(true);
        });
      })
      .catch((err) => {
        setCartErr({ stock: product?.stock, error: err?.response?.data });
        setLoaderOn(false);
      })
      .finally(() => {
        setLoaderOn(false);
      });
  };

  const isOutOfStock = product?.orderType === 'out-of-stock' || product?.stock === 0;

  return (
    <div
      className="row mb__product__list__detail__block"
      onClick={() => redirectToPdpPage(product?.english_name, product?.sku)}
    >
      <div className="col-4 productTen__left__block">
        {/* <div className="productTen__header">
           <div className="productTen__new__sticker__block">
            <p className="productTen__new__sticker__text">{t("New")}</p>
          </div> */}
        {/* <div></div> */}
        {/*<div className="mt-2">
             <img
              src={productTwo_quality_icon}
              alt=""
              className="quality__icon"
            /> 
          </div>
        </div>*/}
        <div className="product__pics__area">
          <Link to={productUrlHelper(product?.english_name, product?.sku)}>
            <div className="productTen__image__slider ps-2">
              {/* <AwesomeSlider
            transitionDelay={0.2}
            mobileTouch={true}
            infinite={true}
          >
            {product?.media?.image?.screenshots?.map((img, index) => (
              <div key={index} className="_product__container_image">
                <img src={img.image} alt={img.image + index} />
              </div>
            ))}
          </AwesomeSlider> */}

              <Slider {...settings}>
                {[product?.baseImage]?.map((img, index) => (
                  <div key={index} className="">
                    <LazyImageForProduct
                      product={product}
                      srcSetReSize={ImageResize}
                      alt={img + index}
                      className=""
                      onClickEvent={true}
                      redirectToPdpPage={redirectToPdpPage}
                    />
                  </div>
                ))}
              </Slider>
            </div>
          </Link>
          <ProductLabel product={product} labelType="plp" />
          <SoldOutProductLabel
            t={t}
            product={product}
            outOfStockConfiguration={outOfStockConfiguration}
          />
        </div>
      </div>
      <div className="col-8 productTen__middle__block">
        <div className="quality__favourite__block">
          <img
            onMouseEnter={() => setIsFavouriteHover(true)}
            onClick={handleFavourite}
            onMouseLeave={() => setIsFavouriteHover(false)}
            className={
              !isFavourite ? "favourite__icon" : "favourite__icon__disable"
            }
            src={isFavouriteHover ? fulfill_favourite : empty_favourite}
            alt=""
          />
          <img
            onClick={handleFavourite}
            className={
              isFavourite ? "favourite__icon" : "favourite__icon__disable"
            }
            src={fulfill_favourite}
            alt=""
          />
        </div>
        <Link
          className="productNine__name__link"
          to={productUrlHelper(product?.english_name, product?.sku)}
        >
          <p className="productNine__name"> {titleChange(product.name)}</p>
          <ProductDeliveryType
            product={product}
            t={t}
            availablityData={availablityData}
          />
          <div className="plp__tamara__box mb-2">
            <TamaraLogoBox product={product} />
          </div>
          {/* <Heading6 text={titleChange(product.name)} marginBottom={10} /> */}
          <div className="plp__mezza__reward d-flex justify-content-between align-items-center mb-2">
            <MizaAndQitaf product={product} />
          </div>
          <div className="mb__product-list-view-pricebox">
            {
              !product?.is_price_hide &&
              <>
                <OldPrice
                  oldPrice={product?.price_rounded}
                  price={
                    product.discounted_price_rounded === null
                      ? product.price_rounded
                      : product.discounted_price_rounded
                  }
                  size="text4"
                  color="#444444"
                  // lineThrough={true}
                  currency={product?.currency}
                />
                <Price
                  price={
                    product.discounted_price_rounded === null
                      ? product.price_rounded
                      : product.discounted_price_rounded
                  }
                  marginBottom={0}
                  size="heading6"
                  currency={product?.currency}
                />
              </>
            }
          </div>
        </Link>

        <RatingBlock rating={6} totalRatings={2222} />

        <div className="productNine__feature__block">
          {product.productFeatures && (
            <>
              {product.productFeatures.map((feature, index) => {
                return (
                  <div key={index} className="feature__text__block">
                    <div className="feature__bullet"></div>
                    <Text4 text={feature.text} />
                  </div>
                );
              })}
            </>
          )}
        </div>
        {product?.additional_estimated_day !== undefined && (
          <div className="mb__delivery__text">
            <DeliveryTimeArea
              additional_estimated_day={product?.additional_estimated_day}
            />
          </div>
        )}
        <div className="mb_cart_com_btn" onClick={(e) => { e.stopPropagation(); e.preventDefault() }}>
          <AddToCartNotify
            product={product}
            AddProductToCart={AddProductToCart}
            outOfStockConfiguration={outOfStockConfiguration}
            loaderOn={loaderOn || spinnerOn}
          />
          {/* {
            product?.orderType === "pre-order" ? (
              <div
                className="addToCart__button pre-order pre-order-mbl"
                onClick={() => AddProductToCart(product.sku)}
              >
                {t("pre_order")}

              </div>
            ) : (
              <div
                onClick={() => AddProductToCart(product.sku)}
                className="addToCart__button"
              >
                <img src={shopping_cart} alt="" className="addToCart__icon" />
              </div>
            )
          } */}
          {/* <button
            onClick={() => updateCompareProduct(true, product)}
            className={`productNine__button__block ${selectedCompareProductStatus(product.id) === true
                ? `active_compare_btn`
                : ``
              }`}
          >
            <HiOutlineSwitchHorizontal className="compare_icon shortlink_icon" />
          </button> */}
        </div>
      </div>
      <MobileCompareBtn
        product={product}
        updateCompareProduct={updateCompareProduct}
        inputName="listCompare"
      />
    </div>
  );
}

export default MobileListViewProduct;
